import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

function Home()
{
    return (
        <div>
            <Helmet>
                <title>Home | Lucas RODRIGUEZ</title> {/* About | Lucas RODRIGUEZ */}
            </Helmet>
            <main>
                <h2>About</h2>
                <div className="row">
                    <div className="fs-6 col-md-7">
                        <p>
                            Engineer with quantitative background working on electronic trading markets.
                            {/* <b>Quantitative & Computational finance</b>, <b>CS</b> & <b>Applied Mathematics</b>. */}
                        </p>
                        <p style={{ 'margin-top': '-12px' }}>
                            Interested in quantitative trading strategies modeling/development & high-performance/low-latency systems design tailored to electronic FX & crypto markets

                            {/* Deeply interested in high-performance/low-latency systems, quantitative/numerical analysis/development tailored to energy & algorithmic trading. */}
                        </p>
                        {/*
                        <p>
                            Graduated from <a href="https://www.universite-paris-saclay.fr/">Paris-Saclay University</a>, <a href="https://www.ensiie.fr/">ENSIIE Paris</a> & <a href="https://www.unibo.it">UNIBO</a>.
                        </p>
                        */}
                        <p>
                            <a className="social" href="https://linkedin.com/in/lcsrodriguez" target="_blank"><i className="fa fa-linkedin"></i>&nbsp;LinkedIn</a> &middot; <a className="social" href="https://github.com/lcsrodriguez" target="_blank"><i className="fa fa-github"></i>&nbsp;Github</a> &middot; <NavLink className="social" to="/contact"><i className="fa fa-envelope"></i>&nbsp;Mail</NavLink>
                            {/* &middot; <a className="social" href="https://medium.com/@lcsrodriguez" target="_blank"><i className="fa fa-medium"></i>&nbsp;Medium</a> */}
                        </p>
                        <br />

                        <NavLink to="/projects" class="btn btn-dark"><i class="fa fa-terminal" style={{ 'margin-right': '5px' }}></i>  Projects</NavLink> &nbsp;
                        <NavLink to="/articles" class="btn btn-dark"><i class="fa fa-file-text-o" style={{ 'margin-right': '5px' }}></i>  Articles</NavLink>


                        {/* <ul>
                            <li><NavLink to="/projects">Projects</NavLink></li>
                            <li><NavLink to="/articles">Articles</NavLink></li>
                        </ul> */}
                    </div>
                    <div className="fs-6 col-md-1">
                    </div>
                    <p className="fs-5 col-md-4 profile_pic_p">
                        {/* <img src="img/profile_pic_2.jpg" id="profile_pic"></img> */}
                    </p>
                </div>

                <hr class="col-3 col-md-2 mb-5 mt-5" />

                <div class="row g-5">
                    <div class="col-md-6">
                        <h2>Interests</h2>
                        <ul>
                            <li>Limit Order books dynamics (<i>tick data</i>) & Microstructure</li>
                            <li>Data architecture & analysis for large datasets subject to severe real-time constraints</li>
                            {/* <li>Extract & Interpret the optimal added value from large & meaningful datasets (GIS, text & temporal data)</li> */}
                            {/*<li>Game & Lottery theories, covering systems design, pattern recognitions</li> */}
                            {/* <li>Quantitative research</li> */}
                            <li>Low-latency systems design (ULLDMA)</li>
                            <li>Query optimization on huge/heterogeneous datasets</li>
                            <li>Market data analysis for insight delivery</li>
                            <li>Column-oriented in-memory DB</li>
                            <li>Time-series processing</li>
                            {/* <li>GPU/FPGAs acceleration</li> */}
                            <li>HFT algorithmic solutions</li>
                            <li>Parallel & Distributed computing</li>
                            {/*<li>Deep learning dedicated to intelligence & military applications</li>*/}
                            {/* <li>Formula 1</li> */}
                        </ul>

                        {/* <h2>Current projects</h2> */}
                        {/* <ul>
                            <li><a href="https://github.com/lcsrodriguez/qkucoin/">qKucoin</a></li>
                        </ul> */}
                    </div>
                    <div class="col-md-6">
                        <h2>Skills</h2>
                        <p></p>
                        <ul>
                            <li><b>Prog. lang.</b>: Python, C/C++, R, OCaml, MATLAB <i>(notions)</i></li>
                            {/* <li><b>Libraries</b>: Pandas, NumPy, SkLearn, Keras, FastAPI, Eigen, Boost, SDL, OpenCV, nltk</li> */}
                            <li><b>DB</b>: SQL, Q/KDB+, Redis, NoSQL <i>(Neo4J)</i></li>
                            <li><b>Cloud</b>: AWS</li>
                            <li><b>Web-dev</b>: HTML, CSS, JS (JQuery, React), PHP, Bootstrap, Leaflet</li>
                            <li><b>CI/CD</b>: GitHub Actions, Jenkins, SonarQube, CodeQL, XL-Deploy, Dependabot, Linters (Flake8, Black, MyPy), Tox, PyTest</li>
                            <li><b>OS</b>: UNIX (Ubuntu 20/22 & Alpine, macOS 15+), Windows [7-10]</li>

                            <li><b>GUI design</b>: PyQT, Tkinter</li>
                            <li><b>Embedded sys.</b>: Arduino, Raspberry Pi</li>
                            {/*<li><b>Workflows</b>: Prefect, Airflow</li>*/}
                            <li><b>Big Data & Msg. broker</b>: Hadoop, Spark, Livy, Zeppelin, RabbitMQ, Kafka + Avro + Kafdrop</li>
                            {/* <li><b>Message broker</b>: RabbitMQ, Apache Kafka</li> */}
                            <li><b>Data-Viz</b>: Grafana, Kibana (ELK), Plotly JS</li>
                            <li><b>Finance</b>: Bloomberg Terminal, XBBG/BLPAPI</li>
                            <li><b>Operations Research</b>: Gurobi, PuLP, CPLEX</li>
                            <li><b>Developer Tools</b>: Git, TFS, Docker, Bash, DOT, PyCharm, DataGrip, Agile Method</li>
                            <li><b>Documentation</b>: Sphinx, Doxygen, MkDocs, ReadTheDocs</li>
                            {/* <li><b>Finance</b>: Bloomberg Terminal, xbbg & blpapi</li> */}
                        </ul>
                        {/* <ul>
                            <li><b>Mathematics</b>: PDE/SDE, Monte Carlo, Time series analysis, Stochastic & Differential calculus, Operations Research methods, Graph theory & Optimization</li>
                            <li><b>Financial maths</b>: Derivatives pricing, Stochastic control, Numerical analysis</li>
                            <li><b>Statistics</b>: Market microstructure & Pre-averaging methods, GARCH models, ACD, Volatility & Interest rates, Kernel methods, Black-Scholes, Hawkes processes</li>
                            <li><b>Programming</b>: Multi-threading, Functional <i>(notions)</i>, Imperative & Oriented-Object Paradigms, Concurrent/Parallel & GPU (PyCUDA) programming <i>(notions)</i>
                            </li>
                        </ul> */}
                    </div>
                </div>
            </main >
        </div >
    );
}

export default Home;